import { InnerContentItem, OuterContentItem } from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { CascadiaJsonFormContext } from "../../../../forms/src/CascadiaJsonFormContext";
import { dataToFile } from "../../utils";

type Education = {
  education_idx: string;
  education_document: string;
  document_type: string;
};

export function EducationtDocumentsSummaryControl(props: ArrayControlProps) {
  const { t } = useTranslation();
  const { values: rootValues } = useContext(CascadiaJsonFormContext);
  const { rootSchema } = props;

  const qualificationTitles = Object.fromEntries(
    (
      rootSchema as any
    )?.properties?.education_history?.properties?.educations?.items?.properties?.qualification?.oneOf?.map(
      ({ const: const_, title }: any) => [const_, title]
    ) || []
  ) as { [key: string]: string };

  const documentTypes = Object.fromEntries(
    (
      rootSchema as any
    )?.properties?.education_documents?.items?.properties?.document_type?.oneOf?.map(
      ({ const: const_, title }: any) => [const_, title]
    ) || []
  ) as { [key: string]: string };

  const educationSummaries = (
    rootValues?.education_history?.educations || []
  ).map(
    ({ institution: { name: institutionName }, qualification }: any) =>
      `${institutionName} - ${qualificationTitles[qualification]}`
  ) as string[];

  const educations = props.data as Education[];

  return (
    <>
      {educations?.map((education, index) => {
        const summary = educationSummaries[Number(education.education_idx)];
        const filename = dataToFile(education.education_document)?.name;
        const documentType = documentTypes[education.document_type];

        return (
          <OuterContentItem
            key={index}
            title={filename}
            subtitle={`${summary}: ${documentType}`}
            testID={`education-documents-summary-${index + 1}`}
          >
            <InnerContentItem
              label={t("Document")}
              testID={`education-documents-summary-document-${index + 1}`}
            >
              {filename}
            </InnerContentItem>
            <InnerContentItem
              label={t("Institution")}
              testID={`education-documents-summary-institution-${index + 1}`}
            >
              {summary}
            </InnerContentItem>
            <InnerContentItem
              label={t("Document type")}
              testID={`education-documents-summary-document-type-${index + 1}`}
            >
              {documentType}
            </InnerContentItem>
          </OuterContentItem>
        );
      })}
    </>
  );
}
